module.exports = __webpack_public_path__ + "static/media/bp-favicon.5038c24c.svg";